import { Endpoints } from 'UI/constants/endpoints';
import { Roles } from 'UI/constants/roles';

export const FORM_FIELDS_MAP = {
  Team: {
    key: 'team'
  },
  Recruiter: {
    key: 'recruiter',
    paramKey: 'assignedTo',
    outboundAccesor: 'id'
  }
};

export const TEAM_ENDPOINTS = {
  coaches: `${Endpoints.Users}?role_id=${Roles.Coach}&checkAsSupervisor=true`,
  recruitersByCoach: coachId => `${Endpoints.Recruiters}/byCoach?coachId=${coachId}`
};
